import { Component } from 'react'
import { Modal } from 'react-bootstrap'
import Button from 'react-bootstrap-button-loader'
import * as ajax from '../Utilities/ajax'

export default class DeleteMacroEco extends Component<any> {
  state = {
    loading: false,
    data: {
      id: undefined,
      title: undefined,
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.props.open) {
      const data = nextProps.open.data || {}
      this.setState({
        loading: false,
        data: data,
      })
    }
  }

  onModalConfirm = async () => {
    const { onClose } = this.props
    const { id } = this.state.data

    this.setState({ loading: true })

    await ajax.destroy(
      `/macroeco?id=${id}`,
    )

    this.setState({ loading: false })
    onClose(true)
  }

  render() {
    const { onClose } = this.props
    const { title } = this.state.data

    return (
      <Modal show={this.props.open.show}>
        <Modal.Header>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            {`Are you sure you want to delete this item ?`}
          </div>

          <div style={{ color: "red", wordBreak: "break-word", lineHeight: 1 }}>
            {title}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            bsStyle="danger"
            loading={this.state.loading}
            onClick={() => this.onModalConfirm()}
          >
            {this.state.loading ? 'Please wait' : 'Delete'}
          </Button>
          <Button bsStyle="default"
            onClick={() => onClose(false)}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}